import {
  object, string, date, array,
} from 'yup';

import { TEMPLATE_TYPES } from './template.constants';

/**
 * @typedef {Object} EmailTemplate
 * @property {string} id
 * @property {string} created_on
 * @property {string} updated_on
 * @property {string} title
 * @property {string} subject
 * @property {string} body
 * @property {string[]} to_emails
 * @property {string[]} cc_emails
 * @property {string[]} bcc_emails
 * @property {string[]} emails
 * @property {string[]} to
 * @property {string} folder_id
 * @property {string} company_id
 * @property {string} type
 * @property {{name: string, id: string}} folder
 */

const templateSchema = object({
  id: string(),
  created_on: date(),
  updated_on: date(),
  title: string().required(),
  subject: string().required(),
  body: string().required(),
  to_emails: array().of(string()).nullable(),
  cc_emails: array().of(string()).nullable(),
  bcc_emails: array().of(string()).nullable(),
  company_id: string().required(),
  type: string().oneOf(Object.values(TEMPLATE_TYPES)).default(TEMPLATE_TYPES.DEFAULT),

  // Deprecated fields, remove after migration 33
  emails: array().of(string()).nullable(),
  to: array().of(string()).nullable(),
});

export default templateSchema;
